module.exports = __webpack_public_path__ + "static/media/ai-translations-soyun-1.1404c0dc.md";